import * as Types from '../../../../../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SetLineItemsV2MutationVariables = Types.Exact<{
  input: Types.SetInvoiceLineItemsV2Input;
}>;


export type SetLineItemsV2Mutation = { readonly __typename?: 'Mutation', readonly setLineItemsV2: { readonly __typename?: 'Invoice', readonly _id: string, readonly lineItems: ReadonlyArray<{ readonly __typename?: 'InvoiceLineItem', readonly id?: string | null, readonly quantity: number, readonly cost: number, readonly disabled: boolean, readonly supplier?: Types.LineItemSupplier | null, readonly priceListItem: { readonly __typename?: 'PriceListItem', readonly uuid?: string | null, readonly name: string, readonly priceListItemType: Types.PriceListItemType, readonly cost: number } }>, readonly balance: { readonly __typename?: 'Balance', readonly total?: number | null, readonly paid?: number | null, readonly due?: number | null, readonly currency?: Types.BillingCurrency | null } } };


export const SetLineItemsV2Document = gql`
    mutation setLineItemsV2($input: SetInvoiceLineItemsV2Input!) {
  setLineItemsV2(input: $input) {
    _id
    lineItems {
      id
      quantity
      cost
      priceListItem {
        uuid
        name
        priceListItemType
        cost
      }
      disabled
      supplier
    }
    balance {
      total
      paid
      due
      currency
    }
  }
}
    `;
export type SetLineItemsV2MutationFn = Apollo.MutationFunction<SetLineItemsV2Mutation, SetLineItemsV2MutationVariables>;

/**
 * __useSetLineItemsV2Mutation__
 *
 * To run a mutation, you first call `useSetLineItemsV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetLineItemsV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setLineItemsV2Mutation, { data, loading, error }] = useSetLineItemsV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetLineItemsV2Mutation(baseOptions?: Apollo.MutationHookOptions<SetLineItemsV2Mutation, SetLineItemsV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetLineItemsV2Mutation, SetLineItemsV2MutationVariables>(SetLineItemsV2Document, options);
      }
export type SetLineItemsV2MutationHookResult = ReturnType<typeof useSetLineItemsV2Mutation>;
export type SetLineItemsV2MutationResult = Apollo.MutationResult<SetLineItemsV2Mutation>;
export type SetLineItemsV2MutationOptions = Apollo.BaseMutationOptions<SetLineItemsV2Mutation, SetLineItemsV2MutationVariables>;